import { render, staticRenderFns } from "./JobMatchingSelector.vue?vue&type=template&id=94efaaa4&scoped=true&"
import script from "./JobMatchingSelector.vue?vue&type=script&lang=ts&"
export * from "./JobMatchingSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94efaaa4",
  null
  
)

export default component.exports